export default __webpack_public_path__ + "static/media/welovemovies_screen_large.59039776.png";